<div class="radio-container" [formGroup]="formGroup" [class.mdc-component-wrapper]="!editFormFieldInput()">
  @if (isMandatory) {
    <p class="radio-required-instruction" data-qa="radio-required-instruction">Please select one option before continuing ( * )</p>
  }
  <mat-radio-group class="radio-group" [value]="selectedControlName()" (change)="radioClick($event.value)">
    @for (input of configJson.inputs; track input.id ?? input.localTrackId; let i = $index) {
      <div class="radio-row">
        @if (editFormFieldInput()) {
          <div class="icon-wrapper">
            <button
              aria-label="Edit form field icon button"
              class="icon-button"
              [attr.data-qa]="'edit-form-field-icon-button-' + i"
              (click)="openEditDrawer(i)">
              <i class="fa-regular fa-pen-to-square icon" [class.edit-highlight]="input.selected"></i>
            </button>
            <button
              aria-label="Remove form field icon button"
              class="icon-button"
              mat-button
              [attr.data-qa]="'remove-form-field-icon-button-' + i"
              [disabled]="configJson.inputs.length <= 2"
              (click)="removeField(i)">
              <i class="fa-regular fa-trash-can icon"></i>
            </button>
          </div>
        }

        <mat-radio-button
          class="radio-component"
          [aria-label]="input.label ?? 'radio-label'"
          [attr.data-qa]="'radio-' + i"
          [value]="controlName(input)"
          [class.pointers]="allowPointerEvents">
          <span class="radio-label" [class.placeholder]="editFormFieldInput()">{{ input.label }}</span>
        </mat-radio-button>
      </div>
    }
  </mat-radio-group>
</div>
@if (showAddRadioButton()) {
  <button
    class="plus-sign-button text-input-field-button"
    data-qa="add-radio-button"
    mat-flat-button
    [disabled]="!enableAddTextInputButton()"
    (click)="addInputField()">
    <i class="fa-solid fa-xl font-bold fa-plus"></i> Radio Button
  </button>
}
